// src/components/Benefits.js
import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Headphones, Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Benefits = () => {
  const { t } = useTranslation();

  const benefits = [
    {
      icon: Zap,
      titleKey: 'benefit_speed_title',
      descKey: 'benefit_speed_desc',
    },
    {
      icon: Headphones,
      titleKey: 'benefit_support_title',
      descKey: 'benefit_support_desc',
    },
    {
      icon: Globe,
      titleKey: 'benefit_coverage_title',
      descKey: 'benefit_coverage_desc',
    },
  ];

  return (
    <section
      id="benefits"
      className="relative z-10 py-32 px-6 text-white overflow-hidden"
    >
      <div className="container mx-auto max-w-6xl">
        {/* Title */}
        <div className="text-center mb-20">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-5xl md:text-6xl font-light tracking-tight mb-6"
          >
            {t('benefits_title')}
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl md:text-2xl text-slate-400 font-light max-w-3xl mx-auto"
          >
            {t('benefits_subtitle')}
          </motion.p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
          {benefits.map((benefit, index) => (
            <motion.div
              key={benefit.titleKey}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="group text-center"
            >
              {/* Icon */}
              <div
                className="
                  inline-flex items-center justify-center
                  w-24 h-24 mb-8 rounded-full
                  border-2 border-orange-500/40
                  bg-slate-900/40 backdrop-blur-sm
                  transition-all duration-500
                  group-hover:border-orange-500
                  group-hover:shadow-[0_0_40px_rgba(249,115,22,0.45)]
                "
              >
                <benefit.icon
                  className="
                    w-12 h-12 text-orange-400
                    transition-all duration-500
                    group-hover:scale-110
                    group-hover:text-orange-300
                  "
                  strokeWidth={1.5}
                />
              </div>

              <h3 className="text-2xl md:text-3xl font-medium mb-4 tracking-tight">
                {t(benefit.titleKey)}
              </h3>

              <p className="text-lg text-slate-400 leading-relaxed max-w-sm mx-auto">
                {t(benefit.descKey)}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
